import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../shared/shared.module';
import { ProviderRoutingModule } from './provider-routing.module';
import { ProviderListComponent } from './provider-list/provider-list.component';
import { ProviderAddComponent } from './provider-add/provider-add.component';
import { ProviderDetailComponent } from './provider-detail/provider-detail.component';
import { ProviderMonthlyComponent } from './provider-monthly/provider-monthly.component';

@NgModule({
    declarations: [
        ProviderListComponent,
        ProviderAddComponent,
        ProviderDetailComponent,
        ProviderMonthlyComponent,
    ],
    imports: [
        CommonModule,
        ProviderRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        NgxSpinnerModule,
        SharedModule,
        AgGridModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProviderModule { }
